// extracted by mini-css-extract-plugin
export default {"info-buttons":"headerContent_info-buttons__xw1yS","info-buttons-without-ribbon":"headerContent_info-buttons-without-ribbon__x3nCy"};